export default __webpack_public_path__ + "static/media/hero3.cb80f097.svg";